// extracted by mini-css-extract-plugin
module.exports = {"root":"slideshow-module--root--3ozvS","nav":"slideshow-module--nav--K5wtg","carousel":"slideshow-module--carousel--32dVS","slide":"slideshow-module--slide--qdhh6"};